export const IGNORED_COLUMNS = [
  'sex',
  'Color 2',
  'quantity',
  'description',
  'folder',
  'photo1',
  'photo2',
  'photo3',
  'photo4',
  'photo5',
  'photo6',
  'photo7',
  'article',
  'group',
  'color_hex',
  'brutto',
  'cur',
  'EUR',
  'DOL',
  'Мой склад',
];

export const TRANSLATIONS: Record<string, string> = {
  size: 'Размер',
  color: 'Цвет',
  brand: 'Бренд',
  category: 'Категория',
  name: 'Название',
  price: 'Цена',
  availability: 'Наличие',
  material: 'Материал',
  subcategory: 'Подкатегория',
};
